


import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Li } from '.'
import { getStageInfo, getStagesForOrg } from '../../../dict/STAGES'
import RootStoreContext from '../../../storage/RootStore'
import { When } from 'react-if'

/// functions
/// types
/// components

interface StagesProps {
    forOrg: string
}

export const Stages: React.FC<StagesProps> = observer(({
    forOrg: orgID
}) => {

    const { selection } = useContext(RootStoreContext)

    return (
        <When condition={getStagesForOrg(orgID).length}>
            <p><b>Етапи де залучено організацію</b></p>
            <ul>
                {getStagesForOrg(orgID).map(stageID => {
                    let { stageName } = getStageInfo(stageID)

                    const id = `stage-${stageID}-connected`

                    const onClick = () => {
                        selection.setStage(stageID)
                        selection.setView('stages')
                    }

                    return (
                        <Li key={id} id={id} onClick={onClick}>
                            {stageName}
                        </Li>
                    )
                })}
            </ul>
        </When>
    )
})
